export default __webpack_public_path__ + "static/media/bugsnag.f5440501.png";